import React, { useState } from 'react';

const OurLives: React.FC = () => {
  const [isColorMode, setIsColorMode] = useState(true);

  return (
    <div className="space-y-24">
      <div className="text-center">
        <h1 className="text-4xl font-display font-medium text-sage-800 mb-4">
          Our Lives Together
        </h1>
        <div className="elegant-divider"></div>
        <p className="text-sage-grey-600">
          A collection of photos of all the random things we do together.
        </p>
      </div>
      
      {/* Photo Gallery Section */}
      <div className="max-w-7xl mx-auto">
        {/* Color Toggle */}
        <div className="flex justify-end mb-4">
          <div className="flex items-center gap-2">
            <span className={`text-xs tracking-wider uppercase ${!isColorMode ? 'text-soft-black' : 'text-text-gray'}`}>
              B&W
            </span>
            <button
              onClick={() => setIsColorMode(!isColorMode)}
              className={`relative inline-flex h-4 w-8 items-center rounded-full transition-colors focus:outline-none focus:ring-1 focus:ring-soft-black focus:ring-offset-1 ${
                isColorMode ? 'bg-soft-black' : 'bg-mid-gray'
              }`}
            >
              <span
                className={`inline-block h-3 w-3 transform rounded-full bg-white transition-transform ${
                  isColorMode ? 'translate-x-4' : 'translate-x-0.5'
                }`}
              />
            </button>
            <span className={`text-xs tracking-wider uppercase ${isColorMode ? 'text-soft-black' : 'text-text-gray'}`}>
              Color
            </span>
          </div>
        </div>
        
        {/* Photo Gallery */}
        <div className="space-y-4">
        
        {/* Row of 3 vertical photos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img 
              src="/images/our-lives/IMG_4678.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img 
              src="/images/our-lives/IMG_1680.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img
              src="/images/our-lives/IMG_1053.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        
        <div className="grid grid-cols-1 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img
              src="/images/our-lives/3D2A7593.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        
        {/* Row of 3 vertical photos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img 
              src="/images/our-lives/IMG_1345.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img
              src="/images/our-lives/IMG_5764.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img
                src="/images/our-lives/FX7000742.JPG"
                alt="Shivangi and Ishan"
                className="w-full h-full object-cover"
                loading="lazy"
                decoding="async"
            />
          </div>
        </div>
        
        {/* Row with 1 horizontal photo */}
        <div className="grid grid-cols-1 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img 
              src="/images/our-lives/IMG_1893.JPG" 
              alt="Shivangi and Ishan" 
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        {/* Row of 3 vertical photos */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img 
              src="/images/our-lives/IMG_9605.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img 
              src="/images/our-lives/FullSizeRender.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
          
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img
              src="/images/our-lives/IMG_8955.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-full object-cover"
              style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
        
        {/* Row with 1 horizontal photo */}
        <div className="grid grid-cols-1 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img
              src="/images/our-lives/IMG_4414.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        {/* Row with 1 horizontal photo */}
        <div className="grid grid-cols-1 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''} aspect-[3/4]`}>
            <img
                src="/images/our-lives/IMG_9964.JPG"
                alt="Shivangi and Ishan"
                className="w-full h-full object-cover"
                style={isColorMode ? { filter: 'contrast(0.9) brightness(0.95)' } : {}}
                loading="lazy"
                decoding="async"
            />
          </div>
        </div>

        {/* 2x2 Grid of 4 horizontal photos */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img 
              src="/images/our-lives/IMG_4477.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img 
              src="/images/our-lives/IMG_4881.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img
              src="/images/our-lives/IMG_5209.JPG"
              alt="Shivangi and Ishan"
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className={`photo-frame ${isColorMode ? 'color' : ''}`}>
            <img 
              src="/images/our-lives/IMG_8363.JPG"
              alt="Shivangi and Ishan" 
              className="w-full h-auto"
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>

        </div>
      </div>
    </div>
  );
};

export default OurLives;